// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --host-header-h: 60px;  /* RBAC platform header height — set to 0px if running standalone */
  --host-footer-h: 48px;  /* RBAC platform footer height — set to 0px if running standalone */
  --green: #86BC25;
  --green-6: #046A38;
  --accessible-green: #26890D;
  --accessible-blue: #007CB0;
  --blue-dark: #00597F;
  --blue-6: #0076A8;

  --jet: #1F1F1F;
  --cg-11: #53565A;
  --cg-9: #75787B;
  --cg-6: #A7A8AA;
  --cg-2: #D0D0CE;
  --hover-gray: #ECECEC;
  --surface: #F2F2F2;
  --surface-raised: #F7F7F7;
  --white: #FFFFFF;

  --red: #DA291C;
  --red-deep: #AB2016;
  --orange: #ED8B00;
  --yellow: #FFCD00;
  --success-green: #046A38;

  --text-on-action: #FFFFFF;

  --surface-error: #FAE9E7;
  --surface-warning: #FFFAE5;
  --surface-success: #E9F2E7;
  --surface-info: #E6F2F7;

  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-6: 24px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;

  --radius-0: 0px;
  --radius-1: 4px;
  --radius-2: 8px;
  --radius-pill: 9999px;

  --shadow-popover: 0 4px 12px rgba(0,0,0,0.08);
  --shadow-modal: 0 12px 40px rgba(0,0,0,0.15);

  --font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-mono: 'SF Mono', 'Fira Code', Consolas, monospace;

  /* Inverse surface — nav is always dark regardless of theme */
  --nav-surface: #1F1F1F;
  --nav-text-active: #FFFFFF;

  /* ── Grooming-layer semantic aliases ──────────────────────────────────────── */
  --color-bg-surface:     var(--white);
  --color-bg-primary:     var(--surface);
  --color-bg-secondary:   var(--surface-raised);
  --color-text-primary:   var(--jet);
  --color-text-secondary: var(--cg-9);
  --color-border:         var(--cg-2);
  --color-accent:         var(--accessible-blue);
  --color-status-error:   var(--red);
  --color-status-warning: var(--orange);
  --color-status-success: var(--accessible-green);
  --color-on-error:       var(--white);
  --shadow-card:          var(--shadow-popover);
  --prim-radius-sm:       var(--radius-1);
  --prim-radius-md:       var(--radius-2);
  --prim-font-size-sm:    11px;
  --prim-font-size-md:    14px;
  --prim-font-size-lg:    16px;
  --prim-font-size-xl:    20px;
  --prim-space-1:         var(--space-1);
  --prim-space-2:         var(--space-2);
  --prim-space-3:         var(--space-3);
  --prim-space-4:         var(--space-4);
  --prim-space-6:         var(--space-6);
  --prim-space-8:         var(--space-8);
}

body {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: var(--jet);
  background: var(--surface);
  margin: 0;
}

@media (prefers-color-scheme: dark) {
  :root {
    --jet:              #F2F2F2;
    --cg-11:            #A7A8AA;
    --cg-9:             #D0D0CE;
    --cg-6:             #75787B;
    --cg-2:             #3A3A38;
    --hover-gray:       #2E2E2C;
    --surface:          #1A1A1A;
    --surface-raised:   #242424;
    --white:            #2C2C2A;

    --accessible-blue:  #4AABE0;
    --blue-dark:        #2A8FBF;
    --blue-6:           #2A9FD0;

    --surface-error:    #3D1F1D;
    --surface-warning:  #3D3520;
    --surface-success:  #1D3020;
    --surface-info:     #1D2D35;

    --success-green:    #86BC25;
    --accessible-green: #4CAF50;

    --shadow-popover: 0 4px 12px rgba(0,0,0,0.3);
    --shadow-modal: 0 12px 40px rgba(0,0,0,0.5);

    --text-on-action: #FFFFFF;
    --nav-surface: #1F1F1F;
    --nav-text-active: #FFFFFF;

    /* ── Grooming-layer semantic aliases (dark) ──── */
    --color-bg-surface:     var(--surface-raised);
    --color-bg-primary:     var(--surface);
    --color-bg-secondary:   var(--surface-raised);
    --color-text-primary:   var(--jet);
    --color-text-secondary: var(--cg-9);
    --color-border:         var(--cg-7);
  }
}

html.dark-mode:root {
  --jet:              #F2F2F2;
  --cg-11:            #A7A8AA;
  --cg-9:             #D0D0CE;
  --cg-6:             #75787B;
  --cg-2:             #3A3A38;
  --hover-gray:       #2E2E2C;
  --surface:          #1A1A1A;
  --surface-raised:   #242424;
  --white:            #2C2C2A;

  --accessible-blue:  #4AABE0;
  --blue-dark:        #2A8FBF;
  --blue-6:           #2A9FD0;

  --surface-error:    #3D1F1D;
  --surface-warning:  #3D3520;
  --surface-success:  #1D3020;
  --surface-info:     #1D2D35;

  --success-green:    #86BC25;
  --accessible-green: #4CAF50;

  --shadow-popover: 0 4px 12px rgba(0,0,0,0.3);
  --shadow-modal: 0 12px 40px rgba(0,0,0,0.5);

  --text-on-action: #FFFFFF;
  --nav-surface: #1F1F1F;
  --nav-text-active: #FFFFFF;

  /* ── Grooming-layer semantic aliases (dark) ──── */
  --color-bg-surface:     var(--surface-raised);
  --color-bg-primary:     var(--surface);
  --color-bg-secondary:   var(--surface-raised);
  --color-text-primary:   var(--jet);
  --color-text-secondary: var(--cg-9);
  --color-border:         var(--cg-7);
}

html.light-mode:root {
  --jet:              #1F1F1F;
  --cg-11:            #53565A;
  --cg-9:             #75787B;
  --cg-6:             #A7A8AA;
  --cg-2:             #D0D0CE;
  --hover-gray:       #ECECEC;
  --surface:          #F2F2F2;
  --surface-raised:   #F7F7F7;
  --white:            #FFFFFF;

  --accessible-blue:  #007CB0;
  --blue-dark:        #00597F;
  --blue-6:           #0076A8;

  --surface-error:    #FAE9E7;
  --surface-warning:  #FFFAE5;
  --surface-success:  #E9F2E7;
  --surface-info:     #E6F2F7;

  --shadow-popover: 0 4px 12px rgba(0,0,0,0.08);
  --shadow-modal: 0 12px 40px rgba(0,0,0,0.15);

  --text-on-action: #FFFFFF;
  --nav-surface: #1F1F1F;
  --nav-text-active: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./pipeline/styles/ascend-tokens.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB,GAAG,mEAAmE;EAC3F,qBAAqB,GAAG,mEAAmE;EAC3F,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;;EAEjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;;EAEhB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;;EAExB,yBAAyB;;EAEzB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;;EAEvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,eAAe;EACf,eAAe;EACf,eAAe;EACf,qBAAqB;;EAErB,6CAA6C;EAC7C,4CAA4C;;EAE5C,qFAAqF;EACrF,wDAAwD;;EAExD,6DAA6D;EAC7D,sBAAsB;EACtB,0BAA0B;;EAE1B,gFAAgF;EAChF,oCAAoC;EACpC,sCAAsC;EACtC,6CAA6C;EAC7C,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,8CAA8C;EAC9C,kCAAkC;EAClC,qCAAqC;EACrC,+CAA+C;EAC/C,oCAAoC;EACpC,6CAA6C;EAC7C,uCAAuC;EACvC,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;;IAE3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;;IAE3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;;IAE3B,2BAA2B;IAC3B,2BAA2B;;IAE3B,4CAA4C;IAC5C,2CAA2C;;IAE3C,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;;IAE1B,mDAAmD;IACnD,6CAA6C;IAC7C,sCAAsC;IACtC,6CAA6C;IAC7C,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;EACrC;AACF;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,4CAA4C;EAC5C,2CAA2C;;EAE3C,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;;EAE1B,mDAAmD;EACnD,6CAA6C;EAC7C,sCAAsC;EACtC,6CAA6C;EAC7C,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,6CAA6C;EAC7C,4CAA4C;;EAE5C,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');\n\n:root {\n  --host-header-h: 60px;  /* RBAC platform header height — set to 0px if running standalone */\n  --host-footer-h: 48px;  /* RBAC platform footer height — set to 0px if running standalone */\n  --green: #86BC25;\n  --green-6: #046A38;\n  --accessible-green: #26890D;\n  --accessible-blue: #007CB0;\n  --blue-dark: #00597F;\n  --blue-6: #0076A8;\n\n  --jet: #1F1F1F;\n  --cg-11: #53565A;\n  --cg-9: #75787B;\n  --cg-6: #A7A8AA;\n  --cg-2: #D0D0CE;\n  --hover-gray: #ECECEC;\n  --surface: #F2F2F2;\n  --surface-raised: #F7F7F7;\n  --white: #FFFFFF;\n\n  --red: #DA291C;\n  --red-deep: #AB2016;\n  --orange: #ED8B00;\n  --yellow: #FFCD00;\n  --success-green: #046A38;\n\n  --text-on-action: #FFFFFF;\n\n  --surface-error: #FAE9E7;\n  --surface-warning: #FFFAE5;\n  --surface-success: #E9F2E7;\n  --surface-info: #E6F2F7;\n\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-6: 24px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n\n  --radius-0: 0px;\n  --radius-1: 4px;\n  --radius-2: 8px;\n  --radius-pill: 9999px;\n\n  --shadow-popover: 0 4px 12px rgba(0,0,0,0.08);\n  --shadow-modal: 0 12px 40px rgba(0,0,0,0.15);\n\n  --font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --font-mono: 'SF Mono', 'Fira Code', Consolas, monospace;\n\n  /* Inverse surface — nav is always dark regardless of theme */\n  --nav-surface: #1F1F1F;\n  --nav-text-active: #FFFFFF;\n\n  /* ── Grooming-layer semantic aliases ──────────────────────────────────────── */\n  --color-bg-surface:     var(--white);\n  --color-bg-primary:     var(--surface);\n  --color-bg-secondary:   var(--surface-raised);\n  --color-text-primary:   var(--jet);\n  --color-text-secondary: var(--cg-9);\n  --color-border:         var(--cg-2);\n  --color-accent:         var(--accessible-blue);\n  --color-status-error:   var(--red);\n  --color-status-warning: var(--orange);\n  --color-status-success: var(--accessible-green);\n  --color-on-error:       var(--white);\n  --shadow-card:          var(--shadow-popover);\n  --prim-radius-sm:       var(--radius-1);\n  --prim-radius-md:       var(--radius-2);\n  --prim-font-size-sm:    11px;\n  --prim-font-size-md:    14px;\n  --prim-font-size-lg:    16px;\n  --prim-font-size-xl:    20px;\n  --prim-space-1:         var(--space-1);\n  --prim-space-2:         var(--space-2);\n  --prim-space-3:         var(--space-3);\n  --prim-space-4:         var(--space-4);\n  --prim-space-6:         var(--space-6);\n  --prim-space-8:         var(--space-8);\n}\n\nbody {\n  font-family: var(--font-family);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--jet);\n  background: var(--surface);\n  margin: 0;\n}\n\n@media (prefers-color-scheme: dark) {\n  :root {\n    --jet:              #F2F2F2;\n    --cg-11:            #A7A8AA;\n    --cg-9:             #D0D0CE;\n    --cg-6:             #75787B;\n    --cg-2:             #3A3A38;\n    --hover-gray:       #2E2E2C;\n    --surface:          #1A1A1A;\n    --surface-raised:   #242424;\n    --white:            #2C2C2A;\n\n    --accessible-blue:  #4AABE0;\n    --blue-dark:        #2A8FBF;\n    --blue-6:           #2A9FD0;\n\n    --surface-error:    #3D1F1D;\n    --surface-warning:  #3D3520;\n    --surface-success:  #1D3020;\n    --surface-info:     #1D2D35;\n\n    --success-green:    #86BC25;\n    --accessible-green: #4CAF50;\n\n    --shadow-popover: 0 4px 12px rgba(0,0,0,0.3);\n    --shadow-modal: 0 12px 40px rgba(0,0,0,0.5);\n\n    --text-on-action: #FFFFFF;\n    --nav-surface: #1F1F1F;\n    --nav-text-active: #FFFFFF;\n\n    /* ── Grooming-layer semantic aliases (dark) ──── */\n    --color-bg-surface:     var(--surface-raised);\n    --color-bg-primary:     var(--surface);\n    --color-bg-secondary:   var(--surface-raised);\n    --color-text-primary:   var(--jet);\n    --color-text-secondary: var(--cg-9);\n    --color-border:         var(--cg-7);\n  }\n}\n\nhtml.dark-mode:root {\n  --jet:              #F2F2F2;\n  --cg-11:            #A7A8AA;\n  --cg-9:             #D0D0CE;\n  --cg-6:             #75787B;\n  --cg-2:             #3A3A38;\n  --hover-gray:       #2E2E2C;\n  --surface:          #1A1A1A;\n  --surface-raised:   #242424;\n  --white:            #2C2C2A;\n\n  --accessible-blue:  #4AABE0;\n  --blue-dark:        #2A8FBF;\n  --blue-6:           #2A9FD0;\n\n  --surface-error:    #3D1F1D;\n  --surface-warning:  #3D3520;\n  --surface-success:  #1D3020;\n  --surface-info:     #1D2D35;\n\n  --success-green:    #86BC25;\n  --accessible-green: #4CAF50;\n\n  --shadow-popover: 0 4px 12px rgba(0,0,0,0.3);\n  --shadow-modal: 0 12px 40px rgba(0,0,0,0.5);\n\n  --text-on-action: #FFFFFF;\n  --nav-surface: #1F1F1F;\n  --nav-text-active: #FFFFFF;\n\n  /* ── Grooming-layer semantic aliases (dark) ──── */\n  --color-bg-surface:     var(--surface-raised);\n  --color-bg-primary:     var(--surface);\n  --color-bg-secondary:   var(--surface-raised);\n  --color-text-primary:   var(--jet);\n  --color-text-secondary: var(--cg-9);\n  --color-border:         var(--cg-7);\n}\n\nhtml.light-mode:root {\n  --jet:              #1F1F1F;\n  --cg-11:            #53565A;\n  --cg-9:             #75787B;\n  --cg-6:             #A7A8AA;\n  --cg-2:             #D0D0CE;\n  --hover-gray:       #ECECEC;\n  --surface:          #F2F2F2;\n  --surface-raised:   #F7F7F7;\n  --white:            #FFFFFF;\n\n  --accessible-blue:  #007CB0;\n  --blue-dark:        #00597F;\n  --blue-6:           #0076A8;\n\n  --surface-error:    #FAE9E7;\n  --surface-warning:  #FFFAE5;\n  --surface-success:  #E9F2E7;\n  --surface-info:     #E6F2F7;\n\n  --shadow-popover: 0 4px 12px rgba(0,0,0,0.08);\n  --shadow-modal: 0 12px 40px rgba(0,0,0,0.15);\n\n  --text-on-action: #FFFFFF;\n  --nav-surface: #1F1F1F;\n  --nav-text-active: #FFFFFF;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
